import React, { useRef, useMemo } from 'react';
import styled from 'styled-components/macro';

import Container from '../Container';
import { getVh } from '../utils';
import useParallax from '../useParallax';
import useTriggerAnimation from '../useTriggerAnimation';

const Uno = styled.img`
  aspect-ratio: 115/111;
  width: 100rem;
  height: auto;
`;

const Dos = styled.img`
  aspect-ratio: 37/36;
  width: 80rem;
  height: auto;
`;

const Tres = styled.img`
  aspect-ratio: 115/111;
  width: 110rem;
  height: auto;

  transform: rotate(15deg);
`;

const Ice = () => {
  const ref = {
    figure: {
      uno: useRef<HTMLElement>(null),
      dos: useRef<HTMLElement>(null),
      tres: useRef<HTMLElement>(null)
    },
    img: {
      uno: useRef<HTMLImageElement>(null),
      dos: useRef<HTMLImageElement>(null),
      tres: useRef<HTMLImageElement>(null)
    }
  }

  const top = {
    uno: useMemo(() => getVh("flavor", 0.9), []),
    dos: useMemo(() => getVh("flavor", 0), []),
    tres: useMemo(() => getVh("faqs", 0.9), [])
  }

  useTriggerAnimation(ref.figure.uno, top.uno);
  useTriggerAnimation(ref.figure.dos, top.dos);
  useTriggerAnimation(ref.figure.tres, top.tres);

  useParallax(ref.img.uno, top.uno, 200);
  useParallax(ref.img.dos, top.dos, 300);
  useParallax(ref.img.tres, top.tres, 100);

  return (
    <>
      <Container
        ref={ref.figure.uno}
        top={top.uno}
        style={{ right: "30vw" }}
      >
        <Uno ref={ref.img.uno} src="/static/images/fill/ice/1.png" />
      </Container>

      <Container
        ref={ref.figure.dos}
        top={top.dos}
        style={{ left: "10vw" }}
      >
        <Dos ref={ref.img.dos} src="/static/images/fill/ice/2.png" />
      </Container>

      <Container
        ref={ref.figure.tres}
        top={top.tres}
        style={{ right: "5vw" }}
      >
        <Tres ref={ref.img.tres} src="/static/images/fill/ice/1.png" />
      </Container>
    </>
  );
}

export default Ice;